import * as React from "react";
import {
  List,
  ListItem,
  Card as MuiCard,
  Typography,
  Box,
  Grid,
} from "@material-ui/core";
import logo from "../../../src/assets/logo.png";
import backIcon from "../../../src/assets/icons/backIcon.svg";
import { useStyles } from "./style";
import HelpSupportIcon from "../Icons/HelpSupportIcon";
import SettingBlueIcon from "../Icons/SettingIconBlue";
import RecommandLightIcon from "../Icons/RecommandLightIcon";
import InteractionIcon from "../Icons/InteractionIcon";
import EyeIcon from "../Icons/EyeIcon";
import ClockIcon from "../Icons/ClockIcon";

interface GeneralScreenProps {
  handleAccessibility: (setting: string) => void; // The function now expects a string argument
}

function AccessiblititySetting({ handleAccessibility }: GeneralScreenProps) {
  const classes = useStyles();
  const settingItem = [
    {
      label: 'Recommended for you',
      icon: RecommandLightIcon
    },
    {
      label: 'Vision enhancements',
      icon: EyeIcon,
    },
    {
      label: 'Interaction and dexterity',
      icon: InteractionIcon,
    },
    {
      label: 'Advance setting',
      icon: SettingBlueIcon
    },
    {
      label: 'About Accessibility',
      icon: HelpSupportIcon,
    },
  ];

  return (
    <>
      <div className={classes.container}>
        <MuiCard className={classes.card}>
          <Box style={{display:'flex',justifyContent:'end', marginBottom:"40px"}}>
            <ClockIcon height={60} width={60}/>
          </Box>
          <Box className={classes.header}>
              <img src={backIcon} alt="Back" className={classes.backIcon} onClick={()=>handleAccessibility('general')} />
            <img src={logo} alt="Logo" className={classes.logo} />
          </Box>
          <Box className={classes.pagetitle}>
            <Typography variant="h5" className={classes.communityHeading}>
              Setting and Preferences
            </Typography>
          </Box>

          <Typography
            variant="h3"
            className={classes.mainTitle}
            style={{ marginTop: "20px"}}
          >
            Accessibility
          </Typography>

          <List className={classes.settingsList}>
            {settingItem.map((item, index) => (
              <ListItem key={index} className={classes.listItem}>
                <Grid container alignItems="center" spacing={2}>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={2}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {/* Render the icon dynamically */}
                    <item.icon width={50} height={50} />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={9}
                    md={10}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Typography
                      variant="h3"
                      className={classes.settingList}
                      style={{ marginTop: "20px", cursor: "pointer" }}
                      // onClick={() => handleGeneralAppSetting(item.label)}
                    >
                      {item.label}
                    </Typography>
                  </Grid>
                </Grid>
              </ListItem>
            ))}
          </List>
        </MuiCard>
      </div>
    </>
  );
}

export default AccessiblititySetting;
